import { Box, List, Text } from '@factorialco/deprecated-design-system'

export const ListItemEmpty = ({ text, title }: { text: string; title?: string }) => {
  return (
    <List.Item>
      <Box gap="s4" flexDirection="column">
        {title && <Text.Normal weight="semibold">{title}</Text.Normal>}
        <Text.Normal>{text}</Text.Normal>
      </Box>
    </List.Item>
  )
}
